import React from 'react';
import { Layout } from '../components/layout/Layout';

export const TermsPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="bg-foreground text-background py-16 md:py-20">
        <div className="container-custom text-center">
          <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4">
            Terms of Service
          </h1>
          <p className="text-background/70">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="container-custom max-w-3xl">
          <div className="prose prose-lg max-w-none space-y-8">
            
            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Agreement to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                By accessing or using The Trade Media website (thetrade.media), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Intellectual Property</h2>
              <p className="text-muted-foreground leading-relaxed">
                All content on The Trade Media, including but not limited to text, graphics, logos, images, audio clips, video clips, and software, is the property of The Trade Media or its content suppliers and is protected by United States and international copyright laws. You may not reproduce, distribute, modify, or create derivative works from any content without our express written permission.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">User Submissions</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                By submitting content to The Trade Media (including story ideas, articles, photos, or videos), you:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Grant us a non-exclusive, royalty-free, perpetual license to use, modify, publish, and distribute your submission</li>
                <li>Represent that you own or have the necessary rights to the content you submit</li>
                <li>Agree that your submission does not violate any third-party rights or applicable laws</li>
                <li>Understand that we are not obligated to publish or use any submission</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Acceptable Use</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                You agree not to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Use our website for any unlawful purpose</li>
                <li>Attempt to gain unauthorized access to our systems or user accounts</li>
                <li>Interfere with or disrupt the website or servers</li>
                <li>Upload or transmit viruses or malicious code</li>
                <li>Scrape, harvest, or collect user information without consent</li>
                <li>Impersonate any person or entity</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Disclaimer of Warranties</h2>
              <p className="text-muted-foreground leading-relaxed">
                The Trade Media is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that our website will be uninterrupted, error-free, or free of viruses or other harmful components. We make no warranties about the accuracy, reliability, or completeness of any content.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Limitation of Liability</h2>
              <p className="text-muted-foreground leading-relaxed">
                To the fullest extent permitted by law, The Trade Media shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our website. Our total liability shall not exceed the amount you paid us, if any, for accessing our services.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Third-Party Links</h2>
              <p className="text-muted-foreground leading-relaxed">
                Our website may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of any third-party sites. Your use of third-party websites is at your own risk.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Indemnification</h2>
              <p className="text-muted-foreground leading-relaxed">
                You agree to indemnify and hold harmless The Trade Media, its affiliates, officers, directors, employees, and agents from any claims, damages, losses, or expenses arising from your use of our website or violation of these terms.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Governing Law</h2>
              <p className="text-muted-foreground leading-relaxed">
                These Terms of Service shall be governed by and construed in accordance with the laws of the United States, without regard to conflict of law principles.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Changes to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website. Your continued use of the website after any changes constitutes acceptance of the new terms.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-2xl font-bold mb-4">Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have questions about these Terms of Service, please contact us at:{' '}
                <a href="mailto:info@thetrade.media" className="text-primary hover:underline">
                  info@thetrade.media
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsPage;
